import { toast } from "sonner";
import { type ZodTypeAny, ZodError } from "zod";
import type z from "zod";

export const isZodError = (error: unknown): error is ZodError => {
  return error instanceof ZodError;
};

export const validateSchema = <T extends ZodTypeAny>(schema: T, data: unknown): z.infer<T> => {
  try {
    return schema.parse(data);
  } catch (error) {
    if (isZodError(error)) {
      toast.error(`${error.issues.map((e) => e.message).join(", ")}`, { id: 'validation-error' });
      throw error;
    }
    toast.error(`Invalid data: ${error}`);
    throw error;
  }
};
